import { useMutation } from "react-query";

import { api } from "../utils";

import { useAuth } from "./useAuth";

interface IFetchPaymentStatusMutationParameters {
    paymentId: string;
}

export const useGetPaymentStatus = () => {
    const auth = useAuth();

    if (!auth.token) {
        throw new Error("Cannot create payment without authorization token.");
    }

    const {
        mutate,
        mutateAsync,
        isIdle,
        isLoading,
        data,
        error,
        isError,
        isSuccess,
    } = useMutation({
        mutationFn: async (
            parameters: IFetchPaymentStatusMutationParameters,
        ): Promise<any> => {
            if (!auth.token) {
                throw new Error(
                    "Cannot create payment session without a valid token.",
                );
            }

            return await api.payments.getPaymentStatus({
                paymentId: parameters.paymentId,
                token: auth.token,
            });
        },
    });

    return {
        mutate,
        mutateAsync,
        isLoading,
        data,
        error,
        isIdle,
        isError,
        isSuccess,
    };
};
